import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import { MrfiktivClearanceViewModelGen, MrfiktivCreateClearanceResponseDtoGen } from "../v1/data-contracts";
import { ClearanceRequest } from "../v1/ClearanceRequest"; // Adjusted import

/**
 * Communicate with ClearanceRequest API
 */
class ClearanceRequestService {
  mrfiktivProxy: ClearanceRequest;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new ClearanceRequest(mrfiktivHttpClientProvider.client());
  }

  /**
   *
   * Gets a report by shared access signature
   *
   * @param partnerId
   * @param clearanceId
   * @param sct
   * @returns
   */
  async getDocumentBySharedAccessToken(
    partnerId: string,
    clearanceId: string,
    sct: string
  ): Promise<MrfiktivClearanceViewModelGen> {
    const shared = await this.mrfiktivProxy.clearanceRequestControllerGet({
      partnerId,
      clearanceId,
      sct
    });

    return shared.data;
  }
  /**
   *
   * Gets a report by shared access signature
   *
   * @param partnerId
   * @param clearanceId
   * @param sct
   * @param data
   * @returns
   */
  async respondAccept(
    partnerId: string,
    clearanceId: string,
    sct: string,
    data: MrfiktivCreateClearanceResponseDtoGen
  ): Promise<MrfiktivClearanceViewModelGen> {
    const shared = await this.mrfiktivProxy.clearanceRequestControllerConfirm({ partnerId, clearanceId, sct }, data);

    return shared.data;
  }
}

/**
 * Communicate with ClearanceRequest API
 */
export default new ClearanceRequestService(new MrfiktivHttpClientProvider());
